// extracted by mini-css-extract-plugin
export default {"container":"InfoBox_container__4ZuLb","itemName":"InfoBox_itemName__4iTMP","price":"InfoBox_price__6GjrP","button":"InfoBox_button__e6Oup"};